import {
  CPSConfig,
  CPSConfigFunctionnality,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P00039DataRxTxIndex } from './P00039Sync';
import { P00041FunctionFinish } from './P00041/Installation/P00041InstallationFinish';
import { P00041FunctionReset } from './P00041/Installation/P00041InstallationReset';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';
import { P00041VoletMiseEnOeuvreInit } from './P00041/Volet/miseenoeuvre/P00041VoletMiseEnOeuvreInit';

export class P00041Data {
  vo24CConfirmationOTA: number = 0;

  vo24CResetUsine: number = 0;

  vo24CUpdateTable: number = 0;

  vo24CCommandeCloud: number = 0;

  vo24CCommandeBLE: number = 0;

  vo24CCodeSaisi: string = '0000';

  vo24IConfigurationProduit: number = 0;

  vo24IAntenneRF: number = 0;

  vo24IInversionMoteur: number = 0;

  vo24IConfigurationAlimentationMoteur: number = 0;

  vo24ITypeCommandeMoteur: number = 0;

  vo24ITypeCommandeContactSec: number = 0;

  vo24ITypeActivationfonctionArretFiltration: number = 0;

  vo24PModeOuverture: number = 0;

  vo24PCodeDeverrouillage: string = '0000';

  vo24SAlarme: number = 0;

  vo24SProtectionInversionSens: number = 0;

  vo24SOuvertureTemporiseeEnCours: number = 0;

  vo24SEtatVolet: number = 0;

  vo24SDeverrouillage: number = 0;

  vo24SSourceCommande: number = 0;

  vo24SCommandeCS1: number = 0;

  vo24SCommandeCS2: number = 0;

  vo24SCommandeA: number = 0;

  vo24SCommandeB: number = 0;

  vo24SCommandeVolet: number = 0;

  vo24SEtatMoteur: number = 0;

  vo24SCommandeBoiteACle: number = 0;

  vo24SCommandeMaitre: number = 0;

  vo24SSourceCommandeMaitre: number = 0;

  vo24SCompteurDeverrouillage: number = 0;

  vo24SDureeFonctionnementMoteur: number = 0;

  vo24SCompteAReboursOuvertureTemporisee: number = 0;

  vo24SNombreCommutationRelaisCS1: number = 0;

  vo24SNombreCommutationRelaisCS2: number = 0;

  vo24SNombreCommutationRelaisA: number = 0;

  vo24SNombreCommutationRelaisB: number = 0;

  vo24SCompteurBouton: number = 0;

  vo24STempsSousTension: number = 0;

  vo24SCompteurResetUsine: number = 0;

  vo24SArretFiltration: number = 0;
}

export class P00041 extends IProduct {
  override deviceTableIndex: number = 17;

  override modelIdentifier?: string = 'P00041';

  override dataIdentifier?: string = 'P00041';

  override manufacturerName?: string = 'ACWA';

  data: P00041Data = new P00041Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P00041/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P00041/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P00041/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P00041;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P00041?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P00041.tuto.installation.help.title',
      helpSlides: [
        'P00041.tuto.installation.help.1',
        'P00041.tuto.installation.help.2',
        'P00041.tuto.installation.help.3',
        'P00041.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00041/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00041/installation-1_dark.png',
          },
          text: 'P00041.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00041/installation-2.png',
            dark: '/assets/ecosystem/images/products/P00041/installation-2_dark.png',
          },
          text: 'P00041.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00041/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00041/installation-1_dark.png',
          },
          text: 'P00041.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P00041/update-2.png',
            dark: '/assets/ecosystem/images/products/P00041/update-2_dark.png',
          },
          text: 'P00041.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [
          /*{
            component: P00041InstallationVolet, condition: () => {
              return true;
            },
          },*/
        ],
        finish: P00041FunctionFinish,
        reset: P00041FunctionReset,
      },
      controlCards: [
        //{ component: P00041CardVoletControle, weight: 4 },
      ],

      statusCards: [
        //{ component: P00041CardVoletStatut, weight: 5 },
      ],

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [EventProductFunctionnalityEnum.COVER];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality,
  ): CPSConfigFunctionnality | null {
    if (functionnality == IProductFunctionnality.VOLET24) {
      return {
        miseEnOeuvre: {
          pages: [
            //{ component : P00041VoletMiseEnOeuvreCouvertureHorsSol, condition: () => { return true; } },
          ],
          init: P00041VoletMiseEnOeuvreInit,
        },

        controle: {
          enabledUser: true,
          enabledSupport: true,

          //component: P00041VoletControle,
        },
        parametrages: {
          enabledUser: true,
          enabledSupport: true,

          reglage: {
            enabledUser: true,
            enabledSupport: true,
            //component: P00041VoletParameters,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          //component: P00041VoletStatut,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            //component: P00041VoletHistoriqueSuivi,
          },
        },
      };
    }
    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return {
      index: P00039DataRxTxIndex.Volet24_Controle,
      propertyName: 'vo24CConfirmationOTA',
    };
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 21;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).vo24IConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.csv'
    );
  }
}
